<typography-v2 *ngIf="props.label" class="v2-mb-1">{{ props.label }}</typography-v2>

<slider
  (setRange)="change($event)"
  [min]="timeToValue(props.values.min_value)"
  [max]="timeToValue(props.values.max_value)"
  [from]="formControl.value?.length ? timeToValue(formControl.value[0]) : 0"
  [to]="formControl.value?.length ? timeToValue(formControl.value[1]) : 0"
  [step]="60000"
  [attr.data-id]="field.key"
  type="time"
></slider>
